import _defineProperty from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _OTHER_PAY_WAY;

import "core-js/modules/es.object.to-string.js";
// 其他支付类型
import { appInfo, CompareVersion } from '@/utils/utils';
import App from '@/utils/app';
import auth from '@/utils/auth';
export var ZFB_PAY_ID = '10000'; // 支付宝payId

export var WX_PAY_ID = '10001'; // 微信payId
// 其他支付类型方式

export var OTHER_PAY_WAY = (_OTHER_PAY_WAY = {}, _defineProperty(_OTHER_PAY_WAY, ZFB_PAY_ID, 'zfb'), _defineProperty(_OTHER_PAY_WAY, WX_PAY_ID, 'wx'), _OTHER_PAY_WAY);
/*
 * 获取token
 * */

export var getAuthToken = function getAuthToken() {
  return new Promise(function (resolve) {
    // 本地token是否存在
    var token = auth.getToken();

    if (token) {
      resolve(token);
    } else {
      // app内直接通过app获取token
      if (appInfo) {
        // 兼容ios获取token
        var tempToken = '';

        if (appInfo.ecopyright === 'ios' && CompareVersion(appInfo.version, '2.7.10')) {
          setTimeout(function () {
            if (!tempToken) {
              resolve('');
            }
          }, 1000);
        }

        App.getToken({}, function () {
          var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          tempToken = token;
          resolve(token);
        });
      } else {
        resolve('');
      }
    }
  });
};